export default __webpack_public_path__ + "static/media/feature4.184f2eb2.svg";